import { render, staticRenderFns } from "./RemovePrebuiltSurveys.vue?vue&type=template&id=327ece48&"
import script from "./RemovePrebuiltSurveys.vue?vue&type=script&lang=ts&"
export * from "./RemovePrebuiltSurveys.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports